<template>
  <div class="sb-tab-panels">
    <slot />
  </div>
</template>

<script lang="ts" setup>
import { provide } from 'vue'
import { SbTabPanelContext } from './types'

export type SbTabPanelsProps = {
  modelValue: string | number
}

export type SbTabPanelsEmits = {
  'update:modelValue': [value: string | number]
}

const props = defineProps<SbTabPanelsProps>()

defineEmits<SbTabPanelsEmits>()

provide(SbTabPanelContext, () => props.modelValue)
</script>
